import { ColorX } from "IZOX/STATIC";

/**
 * 
 * @type {Object.<string, import("../QTable").stylesparams>}
 */
let normal = {
  table: {
    bW: 1,
    bColor: ColorX.CSS("lightGrey")
  },
  headerContainer: {
    style: {
      borderBottomWidth: 1,
      borderBottomStyle: "solid",
      borderBottomColor: ColorX.CSS("lightGrey")
    }
  },
  headerCell: {
    
  },
  headerCellText: {
    fontSize: 14,
    bold: true,
    colorTransition: true,
    color: ColorX.CSS("cmDarkBlue")
  },
  cardHeaderText: {

  },
  cardCell: {
    bold: true,
    fontSize: 14
  },
  headerRow: {
    
  },
  body: {

  },
  row: {

  },
  evenRow: {
    bgColor: ColorX.CSS("aliceblue")
  },
  hoverRow: {
    bgColor: ColorX.CSS("bgYellow", 0.3)
  },
  selectedRow: {
    bgColor: ColorX.CSS("bgGreen", 0.7)
  },
  hoverSelectedRow: {
    bgColor: ColorX.CSS("bgGreen", 0.3)
  },
  cell: {

  },
  cellText: {
    fontSize: 14,
    ellipsisMode: "ellipsis",
    color: ColorX.CSS("cmDarkBlue")
  },
  footerContainer: {

  },
  footer: {
    p: 5,
    style: {
      borderTopWidth: 1,
      borderTopStyle: "solid",
      borderTopColor: ColorX.CSS("lightGrey")
    }
  },
  filterIconShow: {
    color: ColorX.CSS("yellow")
  },
  filterIconHide: {
    color: ColorX.CSS("blue")
  },
  setColumnIcon: {
    color: ColorX.CSS("cmBtnBlue")
  },
  closeIcon: {
    color: ColorX.CSS("red")
  },
  filterInput: {
    bgColor: ColorX.CSS("transparent"),
    color: ColorX.CSS("cmBlue"),
    colorTransition: true
  },
  filterDropDown: {
    bgColor: ColorX.CSS("transparent"),
    color: ColorX.CSS("cmBlue"),
    colorTransition: true
  },
  selectBox: {
    bgColor: ColorX.CSS("pureWhite"),
    bColor: ColorX.CSS("blue"),
    color: ColorX.CSS("pureWhite"),
  },
  inSSFApply: {
    bColor: ColorX.CSS("green"),
    bgColor: ColorX.CSS("green"),
    colorTransition: true
  },
  notSSFApply: {
    bColor: ColorX.CSS("green"),
    bgColor: ColorX.CSS("transparent"),
    colorTransition: true
  },
  inSSFApplyText: {
    color: ColorX.CSS("pureWhite"),
    colorTransition: true
  },
  notSSFApplyText: {
    color: ColorX.CSS("green"),
    colorTransition: true
  },
  inSSFReset: {
    bColor: ColorX.CSS("greyOut"),
    colorTransition: true
  },
  notSSFReset: {
    bColor: ColorX.CSS("greyOut"),
    colorTransition: true
  },
  inSSFResetText: {
    color: ColorX.CSS("greyOut"),
    colorTransition: true
  },
  notSSFResetText: {
    color: ColorX.CSS("greyOut"),
    colorTransition: true
  }
};

export default normal;